document.querySelectorAll('[data-scroll]').forEach(function (button) {
  button.addEventListener('click', function () {
    var rail = document.getElementById(button.dataset.scroll);
    if (!rail) return;
    rail.scrollBy({
      left: Number(button.dataset.dir) * Math.max(280, rail.clientWidth * 0.82),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  });
});

document.querySelectorAll('.ribbon').forEach(function (rail) {
  rail.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    var direction = event.key === 'ArrowLeft' ? -1 : 1;
    rail.scrollBy({
      left: direction * Math.max(280, rail.clientWidth * 0.82),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  });

  var dragging = false;
  var moved = false;
  var startX = 0;
  var startScroll = 0;

  rail.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'touch') return;
    dragging = true;
    moved = false;
    startX = event.clientX;
    startScroll = rail.scrollLeft;
    rail.classList.add('dragging');
    rail.setPointerCapture(event.pointerId);
  });

  rail.addEventListener('pointermove', function (event) {
    if (!dragging) return;
    var distance = event.clientX - startX;
    if (Math.abs(distance) > 7) moved = true;
    rail.scrollLeft = startScroll - distance;
  });

  function stopDrag(event) {
    if (!dragging) return;
    dragging = false;
    rail.classList.remove('dragging');
    if (rail.hasPointerCapture(event.pointerId)) rail.releasePointerCapture(event.pointerId);
  }

  rail.addEventListener('pointerup', stopDrag);
  rail.addEventListener('pointercancel', stopDrag);
  rail.addEventListener('click', function (event) {
    if (!moved) return;
    event.preventDefault();
    event.stopPropagation();
    moved = false;
  }, true);
});
